import { render, staticRenderFns } from "./PaymentUnit.vue?vue&type=template&id=3947238c"
import script from "./PaymentUnit.vue?vue&type=script&lang=ts"
export * from "./PaymentUnit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports